var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOnlinePlatforms = function SvgOnlinePlatforms(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 48,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.727 37.744 15.51-3.035 15.508-14.782L47.11 40.89l15.654-14.24 15.51 1.027",
    stroke: "#FFC53D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1,2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BAE637",
    d: "m.727 17.85 15.51-4.343 15.508-1.597 15.51 26.708 15.509-21.821 15.51-11.773"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#37A3BC",
    d: "m.727 4.772 15.51 37.382 15.367-34.47H47.16l15.604 8.82 15.51.579"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.005 37.758a.9.9 0 1 0 1.8 0 .9.9 0 0 0-1.8 0M15.51 34.723a.9.9 0 1 0 1.8 0 .9.9 0 0 0-1.8 0M30.884 19.943a.9.9 0 1 0 1.8 0 .9.9 0 0 0-1.8 0M47.347 41.915a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8ZM62.057 26.666a.9.9 0 1 0 1.8 0 .9.9 0 0 0-1.8 0M77.572 27.694a.9.9 0 1 0 1.8 0 .9.9 0 0 0-1.8 0",
    fill: "#FFC53D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.005 17.9a.9.9 0 1 0 1.8 0 .9.9 0 0 0-1.8 0M15.51 13.5a.9.9 0 1 0 1.8 0 .9.9 0 0 0-1.8 0M31.026 12.183a.9.9 0 1 0 1.8 0 .9.9 0 0 0-1.8 0M46.447 38.9a.9.9 0 1 0 1.8 0 .9.9 0 0 0-1.8 0M62.057 17.109a.9.9 0 1 0 1.8 0 .9.9 0 0 0-1.8 0M77.572 5.243a.9.9 0 1 0 1.8 0 .9.9 0 0 0-1.8 0",
    fill: "#BAE637"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.005 4.907a.9.9 0 1 0 1.8 0 .9.9 0 0 0-1.8 0M15.4 42.4a.9.9 0 1 0 1.8 0 .9.9 0 0 0-1.8 0M30.884 7.838a.9.9 0 1 0 1.8 0 .9.9 0 0 0-1.8 0M46.447 7.838a.9.9 0 1 0 1.8 0 .9.9 0 0 0-1.8 0M62.057 16.718a.9.9 0 1 0 1.8 0 .9.9 0 0 0-1.8 0M77.572 17.3a.9.9 0 1 0 1.8 0 .9.9 0 0 0-1.8 0",
    fill: "#37A3BC"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9254DE",
    d: "M78.272 8.776 62.811 31.104 47.584 11.722H32.122l-15.508 8.926-15.415.586"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#9254DE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.007 8.92a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0M63.538 31.3a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0M48.304 11.886a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0M32.835 11.886a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0M17.32 20.5a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0M1 22.2a.9.9 0 1 1 0-1.8.9.9 0 0 1 0 1.8Z"
  })))));
};
export default SvgOnlinePlatforms;